import React, { useEffect, useState, useRef } from "react";
import { climeCultureTranslate, employeeExperienceTranslate } from "../../i18n/translatedMessages";
import CulturaBar from "./Components/CulturaBar/CulturaBar";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { getCandidateCultureValues } from "../../API/Candidates/Culture";

// Nuevos estilos CSS
import "./culture.css";
import "./culture.sass";  // Asegúrate de que los estilos SASS estén siendo importados

import { NoteIcon } from "../../Icons/Icons";
import Quiz from "./Components/Quiz/Quiz";

const Culture = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [bars, setBars] = useState([]);
  const [showInfo, setShowInfo] = useState(null);

  const contentRef = useRef();

  const handleCloseInfo = (e) => {
    if (contentRef.current && !contentRef.current.contains(e.target)) {
      setShowInfo(null);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleCloseInfo);

    return () => {
      document.removeEventListener("click", handleCloseInfo);
    };
  }, []);
  
  useEffect(() => {
    const fetchData = async () => {
      const current_user = JSON.parse(localStorage.getItem("user"));

      const responseCulture = await getCandidateCultureValues(localStorage.getItem("candidateId"));
      if (responseCulture.items != null) {
        const current_bars = [
          {
            id: 0,
            icon: "https://assets.mydna.company/Comercial.svg",
            percentagem: parseFloat(responseCulture.items.commercial_percentage).toFixed(2),
            type: climeCultureTranslate.commercial,
            color: "#7a6be6",
          },
          {
            id: 1,
            icon: "https://assets.mydna.company/Disruptivo.svg",
            percentagem: parseFloat(responseCulture.items.disruptive_percentage).toFixed(2),
            type: climeCultureTranslate.disruptive,
            color: "#41c6ff",
          },
          {
            id: 2,
            icon: "https://assets.mydna.company/Colaborativo.svg",
            percentagem: parseFloat(responseCulture.items.collaborative_percentage).toFixed(2),
            type: climeCultureTranslate.collaborative,
            color: "#2be7c8",
          },
          {
            id: 3,
            icon: "https://assets.mydna.company/Tradicional.svg",
            percentagem: parseFloat(responseCulture.items.traditional_percentage).toFixed(2),
            type: climeCultureTranslate.traditional,
            color: "#38364b",
          },
        ];
        setBars(current_bars);
      }
      setIsLoading(false);
    };
    fetchData();
  }, []);

  const handleMouseOver = (item) => {
    let additionalInfo = "";
    switch (item.type) {
      case climeCultureTranslate.commercial:
        additionalInfo = "Orientación a lograr resultados. El ambiente motiva en parte a los colaboradores a cumplir metas. Se puede mejorar. Estilo de liderazgo motiva, pero se puede poner más agresividad comercial. Existe competitividad en el equipo, pero se puede mejorar. Se establecen relaciones con clientes pero no siempre a largo plazo. Se observa en el equipo una mayor satisfacción por ganar y captar mercado. Existen desafíos por crecer pero se puede ser más ambicioso.";
        break;
      case climeCultureTranslate.disruptive:
        additionalInfo = 'Estilo de organización más innovador, se escucha y se trabaja más en equipo. Se planifica más a largo plazo. El liderazgo es más motivador, de tomar riesgos, más emprendedor. Los equipos comienzan a ser más visionarios y a tener más hambre de salir de la caja. Se tiene mayor tolerancia a la diversidad y diferencias entre equipos. La expresión "libertad de hacer" comienza a escucharse más.';
        break;
      case climeCultureTranslate.traditional:
        additionalInfo = "Estilo organizacional que busca establecer permanencia y eficiencia en el tiempo. Ambiente estructurado y controlado por protocolos y procedimientos. En búsqueda constante de eficiencias sin tener que generar cambios bruscos en estructura y equipos. Se trabaja sin contratiempos. Equipo adverso al cambio y a tomar riesgos. La toma de decisiones generalmente pasa por pocas personas. La estrategia se conoce por pocos. La implementación de cambios toma tiempo.";
        break;
      case climeCultureTranslate.collaborative:
        additionalInfo = "Estilo de organización con foco en las personas. Preocupados de generar un ambiente de trabajo grato y cercano. El desarrollo profesional es parte de los desafíos permanentes. Liderazgo incentivando el trabajo en equipo. Existe alta comunicación entre jefaturas y colaboradores. La estrategia es conocida por todos. Equipos alineados y comprometidos con la empresa.";
        break;
      default:
        additionalInfo = "";
    }

    setShowInfo({
      item,
      additionalInfo,
    });
  };


  const handleMouseLeave = () => {
    setShowInfo(null);
  };


  const Statistics = () => (
    <div className="content-cultura">
      <div className="cultura-perfil">
        <ul className="d-flex justify-content-center">
          {bars.map((item) => (
            <li className="card-bars" key={item.id} onMouseOver={() => handleMouseOver(item)} onMouseLeave={handleMouseLeave}>
              <CulturaBar percentagem={item.percentagem} color={item.color}>
                <img src={item.icon} alt="" />
              </CulturaBar>
              <div className="info-container">
                <FontAwesomeIcon icon={faInfoCircle} className="info-icon" />
                {showInfo && showInfo.item.id === item.id && (
                  <div className="additional-info-container">
                    <div className="info-bubble">
                      {showInfo.additionalInfo}
                    </div>
                  </div>
                )}
              </div>
              <span className="item-type">{item.type}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );

  return (
    <div ref={contentRef} className="container-fluid sideMenuSeparator align-items-center">
      <div className="row">
        <div className="col-12">
          <div className="culture-b2e">
            <div className="row d-flex">
              <div className="title-icon p-2 m-auto col-2">
                <NoteIcon />
              </div>
              <div className="col-10">
                <h1 className="titleDescription-section title-my-center">
                  {climeCultureTranslate.myCultureProfile}
                </h1>
                <p className="description-section">{employeeExperienceTranslate.cultureDesc}</p>
              </div>
            </div>
            {!isLoading && (bars.length > 0 ? <Statistics /> : <Quiz />)}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Culture;